"use client";

import type React from "react";
import { useLocation, NavLink } from "react-router-dom";

interface SidebarSectionProps {
  title: string;
  icon: React.ReactNode;
  routes: Route[];
}

interface Route {
  path: string;
  show?: boolean;
  admin?: boolean;
  icon: React.ReactNode;
  name: string;
}

export const SidebarSection = ({
  title,
  routes,
}: SidebarSectionProps) => {
  return (
    <div>
      <p className="mb-1.5 px-3 text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-white/40">
        {title}
      </p>
      <div className="space-y-0.5">
        {routes.map((route, index) => (
          <NavItem key={index} route={route} />
        ))}
      </div>
    </div>
  );
};

const NavItem = ({ route }: { route: Route }) => {
  const location = useLocation();
  const isActive = location.pathname.includes(
    `/admin/${route.path.split("/")[0]}`
  );

  return (
    <NavLink
      to={`/admin/${route.path}`}
      className={`flex items-center gap-2.5 rounded-lg px-3 py-2 text-[13px] transition-colors ${
        isActive
          ? "bg-blue-50 font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
          : "text-gray-600 hover:bg-gray-50 hover:text-gray-900 dark:text-white/60 dark:hover:bg-navy-700 dark:hover:text-white"
      }`}
    >
      <span
        className={`flex-shrink-0 ${
          isActive
            ? "text-blue-600 dark:text-blue-400"
            : "text-gray-400 dark:text-white/40"
        }`}
      >
        {route.icon}
      </span>
      <span>{route.name}</span>
    </NavLink>
  );
};
